export default __webpack_public_path__ + "static/media/EG_ReSynth-2.b299127a.wav";